import LazyLoad from "react-lazyload"
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
const SeniorWing = () => {
    const homeMenu = [
        {
            label: "Curriculum", link: "", subMenu: [
                { label: "Primary Wing", link: "/primarywing" },
                { label: "Middle Wing", link: "/middleWing" },
                { label: "Senior Wing", link: "/seniorWing" },
                { label: "Curriculum", link: "/curriculum" },
            ]
        },

        {
            label: "Extended Classroom", link: "", subMenu: [
                { label: "Labs", link: "/mathmatics" },
                { label: "Excursions", link: "/excursions" },
                { label: "Library", link: "/library" },
                { label: "Field Trips", link: "/feildTrip" },
                { label: "Astronomy", link: "/astronomy" },
            ]
        },
        {
            label: "Sports", link: "", subMenu: [
                { label: "Sports", link: "/sports" },
                { label: "Achievements in Sports 2022-23", link: "/acheivementInSports" },
            ]
        },
        {
            label: "Arts", link: "", subMenu: [
                { label: "Performing Arts", link: "/music" },
                { label: "Visual Arts", link: "/visualArts" }
            ]
        },

        { label: "Houses", link: "/houses" },
        { label: "Assembly", link: "/assembly" },
        { label: "Book List", link: "/booklist" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner-senior.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Senior Wing" breadEnd="Learning Approach" breadMid="Senior Wing" />
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-xl-12 mb-4">
                            <h5 className="text-center color-green mb-4"><i>“Are we forming children who are only capable of learning what is already known?”<br />-Jean Piaget</i></h5>
                            <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/senior1.jpg" className="float-end wid-500 m-2" alt="Lotus Valley Gurgaon" />
                            <p>At Lotus Valley, we are of the fervent view that learners should be allowed to discover rather than be instructed about already known facts. Endorsing the view propounded by eminent developmental psychologist, Jean Piaget, “when you teach a child something you take away forever his chance of discovering it for himself”, classes at Lotus Valley have been designed to ignite the curiosity of young minds, nurture critical and lateral thinking and encourage creativity and innovation. The aim is to equip learners with the skills and competencies required to face the challenges of the 21st century world, thereby preparing them for life. The School lays emphasis on STEM Education to foster scientific temperament in the learners.

                            </p>
                            <p>The Educational Programme at Lotus Valley, as per the guidelines of the Central Board of Secondary Education, provides a variety of subject choices to the learners. The curriculum is further enriched by the School through an innovative and interdisciplinary approach.

                            </p>
                            <p>The teaching methodology is based on experiential learning to enable learners to acquire a better grasp of diverse concepts. Higher order thinking skills and value based questions form an integral part of the learning process. Department Weeks are organized on a regular basis to foster love for subjects and further the students’ knowledge and understanding of the subjects.

                            </p>
                            <p>Developments at the International level are integrated into the teaching approach through sessions by faculty members from foreign schools and faculty exchange programs. The School’s collaborations with international organizations like Brown University, USA, and exchange programmes with The Ravensbourne School in UK and Clara Schumman Gymnasium in Germany have greatly contributed towards broadening the horizons of our learners.
                            </p>


                        </div>

                        <div className="col-xl-12 mb-4">
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/senior2.jpg" className="float-start wid-500 m-2 pe-3" alt="Lotus Valley Gurgaon" /></LazyLoad>
                            <p>Activity based learning is marked across subjects. Languages are nurtured through radio shows, role plays, interviews, among others. Learners create book jackets, write book reviews and analyze narrative styles of different authors to grasp literary texts. Drama, music and art are woven into the teaching methodology to further strengthen love for languages.</p>
                            <p>Love and interest in Mathematics is nurtured through mathematical games, use of manipulatives, Vedic Math techniques among others.</p>
                            <p>The teaching of Humanities is designed to enable learners to comprehend and appreciate diverse cultures, customs and people. The Sciences are nurtured through innovation and experimentation. Multiple Intelligence board games and working models pique the curiosity of our young learners and foster innovation. Innovations by Lotus Valley learners on sustainable use of renewable resources have been recognized by CBSE. Field trips, surveys, analysis of results and presentations on diverse financial happenings and issues enrich the repertoire of Commerce students, and give them a practical experience of their field of study.</p>
                            <p>At Lotus Valley, the role of a Senior School Educator is that of a facilitator, nurturing the eductive ability of the learners, and illuminating the possibility of unraveling multiple approaches to analyzing a task at hand. We recognize the importance of accommodating differential learning styles and assimilating these indispensable determinants in the teaching pedagogies, considering ‘differentiation’ as a virtue and strength for the learning process.</p>
                            <p>Discerning the significance of perspective building, a senior school classroom at Lotus Valley, provides an open - ended manifesto of providing opinions and thinking comprehensively and thoroughly about a subject matter.</p>
                           
                            <p>We acknowledge the importance of unconventional and free spirited ways of education, and are of the fervent view that the educational approach should facilitate the process of tuning the permeable boundaries of the curious minds, and making them more sensitive, socially accountable and integrated.</p>
                        </div>
<div className="col-12">
<LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/senior3.jpg" className="w-100" alt="Lotus Valley Gurgaon" /></LazyLoad>
</div>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}
export default SeniorWing